if (!window.Eurus.loadedScript.has('pagination.js')) {
  window.Eurus.loadedScript.add('pagination.js');

  requestAnimationFrame(() => {
    document.addEventListener("alpine:init", () => {
      Alpine.data("xPagination", (sectionId) => ({
        loading: false,
        loadedUrls: null,
        init() {
          // Keep loaded pages across Alpine re-inits (the button block is re-rendered after each page load)
          window.Eurus.paginationLoadedUrls = window.Eurus.paginationLoadedUrls || {};
          this.loadedUrls = window.Eurus.paginationLoadedUrls[sectionId] = window.Eurus.paginationLoadedUrls[sectionId] || new Set();
        },
        async loadData(url) {
          if (this.loading) return;

          const isMobile = window.innerWidth < 768;
          const grid = document.getElementById('items-grid');
          const mobileBatch = parseInt(grid?.dataset?.mobileBatch || '0', 10);
          const hiddenMobileItems = grid ? Array.from(grid.querySelectorAll('.is-mobile-hidden')) : [];

          if (isMobile && mobileBatch > 0 && hiddenMobileItems.length > 0) {
            this.loading = true;
            let fetchNextPage = false;
            try {
              const toReveal = hiddenMobileItems.slice(0, mobileBatch);
              for (let i = 0; i < toReveal.length; i++) {
                if (i > 0) await new Promise(r => setTimeout(r, 60));
                const item = toReveal[i];
                item.classList.remove('is-mobile-hidden', 'hidden');
                item.classList.add('x-pagination-slide-up');
                requestAnimationFrame(() => {
                  requestAnimationFrame(() => item.classList.add('x-pagination-slide-up--in'));
                });
              }
              this._updateMobileCount();
              if (grid.querySelectorAll('.is-mobile-hidden').length > 0) {
                this._recheckSentinel();
                return;
              }
              const nextLink = document.querySelector(`#btn-pagination-${sectionId} a[href]`);
              if (!nextLink || !nextLink.getAttribute('href') || !url) {
                const btnContainer = document.getElementById(`btn-pagination-${sectionId}`);
                if (btnContainer) {
                  const btn = btnContainer.querySelector('button');
                  if (btn) btn.style.display = 'none';
                }
                return;
              }
              // All hidden items revealed and a next page exists: load it now instead of waiting for another scroll
              fetchNextPage = true;
            } finally {
              this.loading = false;
            }
            if (!fetchNextPage) return;
          }

          if (!url) return;

          if (!this.loadedUrls) this.loadedUrls = new Set();
          const cleanUrl = url.split('#')[0];
          if (this.loadedUrls.has(cleanUrl)) return;

          this.loading = true;
          this.loadedUrls.add(cleanUrl);

          try {
            const response = await fetch(url);
            const text = await response.text();
            const html = new DOMParser().parseFromString(text, 'text/html');
            const productGrid = html.getElementById('items-grid');
            if (!productGrid) {
              this._renderButton(html);
              return;
            }

            const target = document.getElementById('blog-grid') || document.getElementById('items-grid');
            if (!target) return;

            // Immediately update the pagination button/sentinel with next page to prevent duplicate triggers
            this._renderButton(html);

            // Deduplicate products: get existing product keys already in the grid
            const existingProductKeys = new Set(
              Array.from(target.querySelectorAll('a.x-card-title, a.link-product-variant, [data-view-key]'))
                .map(el => el.getAttribute('data-view-key') || el.getAttribute('href')?.split('?')[0])
                .filter(Boolean)
            );

            const newProducts = Array.from(productGrid.querySelectorAll('.grid-item')).filter(item => {
              const cardTitleOrLink = item.querySelector('a.x-card-title, a.link-product-variant, [data-view-key]');
              if (!cardTitleOrLink) return true;
              const key = cardTitleOrLink.getAttribute('data-view-key') || cardTitleOrLink.getAttribute('href')?.split('?')[0];
              if (key && existingProductKeys.has(key)) {
                return false; // Skip duplicate product
              }
              if (key) existingProductKeys.add(key);
              return true;
            });

            for (let i = 0; i < newProducts.length; i++) {
              if (i > 0) await new Promise(r => setTimeout(r, 60));
              const item = newProducts[i];
              item.classList.add('x-pagination-slide-up');
              if (isMobile && mobileBatch > 0 && i >= mobileBatch) {
                item.classList.add('is-mobile-hidden', 'hidden');
              }
              target.appendChild(item);
              if (window.Alpine && window.Alpine.initTree) {
                window.Alpine.initTree(item);
              }
              requestAnimationFrame(() => {
                requestAnimationFrame(() => item.classList.add('x-pagination-slide-up--in'));
              });
            }

            if (isMobile && mobileBatch > 0) {
              this._updateMobileCount();
            }
          } catch (e) {
            console.error(e);
            if (this.loadedUrls && cleanUrl) {
              this.loadedUrls.delete(cleanUrl);
            }
          } finally {
            this.loading = false;
            requestAnimationFrame(() => {
              window.yotpoWidgetsContainer?.initWidgets?.();
            });
            this._recheckSentinel();
          }
        },
        // If the infinite-scroll trigger is still on screen after loading, continue loading.
        // IntersectionObserver only fires on enter, so without this it waits until the user scrolls away and back.
        _recheckSentinel() {
          requestAnimationFrame(() => {
            const box = document.getElementById(`btn-pagination-${sectionId}`);
            if (!box) return;
            const sentinel = Array.from(box.querySelectorAll('div')).find(el => el.hasAttribute('x-intersect.margin.500px'));
            if (!sentinel) return;
            const rect = sentinel.getBoundingClientRect();
            if (rect.width === 0 && rect.height === 0) return;
            if (rect.top < window.innerHeight + 500 && rect.bottom > -500) {
              const match = (sentinel.getAttribute('x-intersect.margin.500px') || '').match(/loadData\('([^']*)'\)/);
              this.loadData(match ? match[1] : '');
            }
          });
        },
        _updateMobileCount() {
          const grid = document.getElementById('items-grid');
          if (!grid) return;
          const visibleItems = Array.from(grid.querySelectorAll('.grid-item:not(.hidden):not(.is-mobile-hidden)'))
            .filter(item => item.querySelector('a[href*="/products/"]')).length;
          const countSpans = document.querySelectorAll('.mobile-showing-count');
          countSpans.forEach(span => {
            span.textContent = visibleItems;
          });
        },
        _renderButton(html) {
          const destination = document.getElementById(`btn-pagination-${sectionId}`);
          const source = html.getElementById(`btn-pagination-${sectionId}`);
          if (destination && source) {
            destination.innerHTML = source.innerHTML;
            if (window.Alpine) {
              window.Alpine.initTree(destination);
            }
            this._updateMobileCount();
          }
        }
      }));
    });
  });
}